import { t } from "i18next";
import React from "react";
import {ContactSubtabsEnum, IContactSubtabsProps} from "./~types/ContactSubtabsProps";

import "./ContactSubtabs.css"

const ContactSubtabs = (props: IContactSubtabsProps) => {

    const getClassName = (tab: ContactSubtabsEnum) => {
        return "contact-subtabs__tab" + (props.selectedTab === tab ? " checked" : "")
    }

    return (
        <div className="contact-subtabs__container">
            <span className={getClassName(ContactSubtabsEnum.contactCommunications)}
                onClick={()=> props.onTabChanged(ContactSubtabsEnum.contactCommunications)}>
                    {t('common.contactCommunications')}
            </span>
            <span className={getClassName(ContactSubtabsEnum.accounts)}
                onClick={()=> props.onTabChanged(ContactSubtabsEnum.accounts)}>
                    {t('common.accounts')}
            </span>
        </div>
    )
}

export default ContactSubtabs;